import { render, staticRenderFns } from "./BuscadorFacturacion.vue?vue&type=template&id=3681814c&"
import script from "./BuscadorFacturacion.vue?vue&type=script&lang=ts&"
export * from "./BuscadorFacturacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports